/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const createUrl = (filterId: string): string => `/rest/api/3/filter/${filterId}`;

const deleteRest = (filterId: string): Promise<void> => performDeleteRequest(createUrl(filterId));

export default deleteRest;
